/**
	Типов данных в постгресе много и мы решили оперировать их группами (синтетическими типами, псевдотипами)
	1) для серверных нужд (чтобы не ходить в БД при построении запроса)
	2) для клиентских нужд (например, все виды дат будут тупо DATETIME)
*/

// Типы для сервера
// https://wiki.oooinex.ru/pages/viewpage.action?pageId=47743062
// в массивах перечисляются соответствующие типы БД Postgres
export const serverTypes = {
	INTEGER: ['integer', 'serial', 'smallint', 'int', 'int2', 'int4'],
	BIGDECIMAL: ['decimal', 'numeric'],
	LONG: ['bigint', 'int8', 'bigserial'],
	DOUBLE: ['double precision'],
	STRING: ['character varying', 'text', 'json', 'jsonb', 'jsonpath', 'character'],
	TIMESTAMP: ['timestamp without time zone', 'timestamp with time zone'],
	TIME: ['time without time zone', 'time with time zone'],
	DATE: ['date'],
	BOOLEAN: ['boolean'],
};

// Типы для клиента
// в массивах перечисляются соответствующие типы для сервера
export const clientTypes = {
	NUMBER: ['INTEGER', 'BIGDECIMAL', 'DOUBLE', 'LONG'],
	STRING: ['STRING'],
	DATETIME: ['TIMESTAMP', 'TIME', 'DATE'],
};

/**
 * Получение кода серверного типа (contentType) по типу БД (dbcoltype)
 * @param {string} t Тип из поля field.dbcoltype
 * @returns {string}
 */
export function getServerTypeByDbType(t) {
	const typeNames = Object.keys(serverTypes); // only own properties, eslint заставил
	for (const typeName of typeNames) {
		for (let i = 0; i < serverTypes[typeName].length; i++) {
			if (serverTypes[typeName][i] === t) {
				return typeName;
			}
		}
	}

	return `SERVER_TYPE_UNKNOWN_FOR [${t}]`;
}

/**
 * Получение клиентского типа по серверному (contentType)
 * @param {string} t Тип из поля field.contentType
 * @returns {string}
 */
export function getClientTypeByServerType(t) {
	const typeNames = Object.keys(clientTypes); // only own properties, eslint заставил
	for (const typeName of typeNames) {
		for (let i = 0; i < clientTypes[typeName].length; i++) {
			if (clientTypes[typeName][i] === t) {
				return typeName;
			}
		}
	}

	return `CLIENT_TYPE_UNKNOWN_FOR [${t}]`;
}

// Получение клиентского типа по типу БД
function getClientTypeByDbType(t) {
	return getClientTypeByServerType(getServerTypeByDbType(t));
}

// Получение клиентского типа по имени колонки и метаданным АРМ
function getDbTypeByArmMeta(armMeta, dbcolname) {
	return armMeta.fields.filter(function (f) {
		return f.dbcolname === dbcolname;
	})[0].dbcoltype;
}

function armColClientTypeIsDate(armMeta, dbcolname) {
	return getClientTypeByDbType(getDbTypeByArmMeta(armMeta, dbcolname)) === 'DATETIME';
}

export default {
	armColClientTypeIsDate,
	getServerTypeByDbType,
	getClientTypeByDbType,
};
